import { createContext, useContext } from 'react';

const NotificationsContext = createContext();

export const useNotificationsContext = () => {
  return useContext(NotificationsContext);
};

export default NotificationsContext;
